export const isProduction = !(/localhost|simsir-lin|192/.test(window.location.href))
export const host = isProduction ? 'https://moonrise.com.cn' : 'https://simsir-lin.cn' // 'http://127.0.0.1:7003'
